"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilCompress = exports.EventCompressionType = void 0;
const _ = require("lodash");
const zlib_1 = require("zlib");
var EventCompressionType;
(function (EventCompressionType) {
    EventCompressionType["NONE"] = "none";
    EventCompressionType["KEYS"] = "keys";
    EventCompressionType["GZIP"] = "gzip";
})(EventCompressionType = exports.EventCompressionType || (exports.EventCompressionType = {}));
class UtilCompress {
    static async compress(data, compression) {
        switch (compression) {
            case EventCompressionType.KEYS: {
                if (!_.isObject(data)) {
                    return { data, mapping: undefined };
                }
                const mapping = Object.create(null);
                return { data: UtilCompress.keysEncode(data, mapping), mapping };
            }
            case EventCompressionType.GZIP: {
                const gzipped = zlib_1.gzipSync(JSON.stringify(data));
                return { data: gzipped.toString("base64"), mapping: undefined };
            }
            default:
                return { data, mapping: undefined };
        }
    }
    static async uncompress(data, attributes) {
        if (attributes && attributes.compression == EventCompressionType.KEYS && attributes.mapping) {
            return UtilCompress.keysDecode(data, attributes.mapping);
        }
        if (attributes && attributes.compression === EventCompressionType.GZIP) {
            const payload = Buffer.from(data, "base64");
            const ungzipped = zlib_1.gunzipSync(payload);
            return JSON.parse(ungzipped.toString());
        }
        return data;
    }
    static keysDecode(obj, mapping) {
        if (_.isArray(obj)) {
            return obj.map(item => UtilCompress.keysDecode(item, mapping));
        }
        if (_.isObject(obj)) {
            const result = Object.create(null);
            _.forOwn(obj, (value, key) => {
                result[mapping[key]] = UtilCompress.keysDecode(value, mapping);
            });
            return result;
        }
        return obj;
    }
    static keysEncode(obj, mapping) {
        if (_.isArray(obj)) {
            return obj.map(item => UtilCompress.keysEncode(item, mapping));
        }
        if (_.isObject(obj)) {
            const result = Object.create(null);
            _.forOwn(obj, (value, key) => {
                result[UtilCompress.getKeyMinimized(key, mapping)] = UtilCompress.keysEncode(value, mapping);
            });
            return result;
        }
        return obj;
    }
    static getKeyMinimized(key, mapping) {
        const reverseMapping = UtilCompress.getReverseMapping(mapping);
        if (reverseMapping[key]) {
            return reverseMapping[key];
        }
        const fakekKey = key + "123456789"; //ugly pseudo collision prevention
        for (let i = 1; i <= fakekKey.length; i++) {
            const partial = fakekKey.substring(0, i);
            if (!mapping[partial]) {
                mapping[partial] = key;
                reverseMapping[key] = partial;
                return reverseMapping[key];
            }
        }
        throw new Error("Can't get minimized key for '" + key + "' with mapping " + (mapping ? JSON.stringify(mapping) : mapping));
    }
    static getReverseMapping(mapping) {
        const result = Object.create(null);
        for (let k in mapping) {
            result[mapping[k]] = k;
        }
        return result;
    }
}
exports.UtilCompress = UtilCompress;
//# sourceMappingURL=util-compress.js.map